/* eslint-disable linebreak-style */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { compose, setPropTypes } from 'recompose';
import { loadUserAmendRequest } from '../../../actions/userInfo';
import { showLightbox, closeLightbox } from '../../../actions/lightbox';
import Fieldset from '../../common/Fieldset';
import Input from '../../common/Input';
import ProfileAction from './ProfileAction';
import Lightbox from '../../common/Lightbox';
import trimHyphen from '../helpers/trimHyphen';
import check from '../../../helpers/check';
import { getActiveSubscription } from '../../../selectors';
import styles from './Profile.scss';

const PROFILE_FORM = 'profile';
const defaultUserInfo = {
  firstName: '',
  lastName: '',
  email: '',
  emailChanged: false,
  customParameters: {
    appSubscriber: 'false',
  },
};
const selector = formValueSelector(PROFILE_FORM);
const modalText = {
  success: 'Your changes have been saved',
  error: 'Sorry. We can\'t save your changes right now. Please try again later',
};

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saveChangesClicked: false,
      detailsChanged: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.saveChangesClicked && this.props.fetching && !nextProps.fetching) {
      this.props.showLightbox();
      this.setState({ saveChangesClicked: false });
    }
    if (this.arePersonalDetailsChanged(nextProps) && !this.state.detailsChanged) {
      this.setState({ detailsChanged: true });
    }
    if (!this.arePersonalDetailsChanged(nextProps)) {
      this.setState({ detailsChanged: false });
    }
  }

  onResetPass = () => {
    global.authApi.showResetPass(this.props.initialValues.email);
  };

  handleSaveClick = () => {
    this.setState({ saveChangesClicked: true });
    this.props.handleSubmit(this.handleSave)();
  };

  handleSave = (values) => {
    const config = {
      firstName: values.firstname,
      lastName: values.lastname,
    };

    if (this.props.emailChanged) {
      config.email = values.email;
    }

    this.props.loadUserAmendRequest(config);
  };

  arePersonalDetailsChanged = nextProps => (
    nextProps.emailChanged || nextProps.firstnameChanged || nextProps.lastnameChanged
  )

  render() {
    return (
      <form
        className={styles.root}
        name={PROFILE_FORM}
        onSubmit={this.setStatehandleSaveClick}
          >
        <div className={styles.formContentWrap}>
          <div className={styles.myAccountLeft}>
            <Fieldset label="Personal Details">
              <Field
                name="firstname"
                type="text"
                component={Input}
                label="First Name"
                customProps={{
                              input: { maxLength: 20, autoComplete: 'off' },
                          }}
                      />
              <Field
                name="lastname"
                type="text"
                component={Input}
                label="Surname"
                customProps={{
                              input: { maxLength: 20, autoComplete: 'off' },
                          }}
                      />
              {/* should apply validation for maxLength */}
              <Field
                name="email"
                type="text"
                component={Input}
                label="Email Address"
                customProps={{
                              input: { maxLength: 100, autoComplete: 'off' },
                          }}
                      />

            </Fieldset>
          </div>
          <div className={styles.myAccountRight}>
            <Fieldset label="Email Communication">
              <div>To amend your email preferences please follow the ‘update your preferences’ link at the bottom of any Racing Post email!</div>
            </Fieldset>
            {this.props.customParameters.appSubscriber &&
            this.props.customParameters.appSubscriber.toLowerCase() === 'true' &&
            <Fieldset label="App Subscriber">
              <div>You can manage your subscription in your mobile device settings</div>
            </Fieldset>}
          </div>
        </div>
        <ProfileAction
          label="Save Changes"
          disabled={this.props.pristine || this.props.submitting || this.props.fetching || !this.props.valid}
          fetching={this.props.fetching}
          onAction={this.handleSaveClick}
              />
        <Lightbox
          open={this.props.lightbox}
          onClose={this.props.closeLightbox}
          className={styles.modal}
        >
          <div className={styles.message}>{this.props.amendSucceded ? modalText.success : modalText.error}</div>
          <button className="ui-btn ui-btn_primary ui-btn_large" onClick={this.props.closeLightbox}>Close</button>
        </Lightbox>
      </form>
    );
  }
}

function validate(values) {
  const errors = {};

  /* replace "smart" quotes with regular ones (since iOS 11.0 the default iOS keyboard uses "smart" quotes, which are different characters) */
  const firstname = values.firstname.replace(/[\u2018\u2019]/g, "'");
  const lastname = values.lastname.replace(/[\u2018\u2019]/g, "'");

  errors.firstname = check(firstname)
    .required()
    .withMessage('Please specify your first name')
    .pattern(/^[a-z'\- ]+$/i)
    .withMessage('Valid characters are letters, spaces, hyphens and single quotations')
    .validate();

  errors.lastname = check(lastname)
    .required()
    .withMessage('Please specify your surname')
    .pattern(/^[a-z'\- ]+$/i)
    .withMessage('Valid characters are letters, spaces, hyphens and single quotations')
    .validate();

  errors.email = check(values.email)
    .required()
    .withMessage('Please specify your email')
    .pattern(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2}(?:[a-z0-9-]*[a-z0-9])?$/i)
    .withMessage('Please use a valid email address')
    .validate();

  return errors;
}

function mapStateToProps(state) {
  const userInfo = {
    ...defaultUserInfo,
    ...state.userInfo.data,
  };

  return {
    initialValues: {
      firstname: trimHyphen(userInfo.firstName),
      lastname: trimHyphen(userInfo.lastName),
      email: userInfo.email,
    },
    fetching: state.userInfo.fetching,
    amendSucceded: !state.userInfo.error,
    emailChanged: userInfo.email !== selector(state, 'email'),
    firstnameChanged: userInfo.firstName !== selector(state, 'firstname'),
    lastnameChanged: userInfo.lastName !== selector(state, 'lastname'),
    customParameters: userInfo.customParameters,
    hasActiveSubscription: Boolean(getActiveSubscription(state)),
    lightbox: state.lightbox,
  };
}

export default compose(
  setPropTypes({
    hasActiveSubscription: PropTypes.bool.isRequired,
  }),
  connect(mapStateToProps, { loadUserAmendRequest, closeLightbox, showLightbox }),
  reduxForm({
    form: PROFILE_FORM,
    enableReinitialize: true,
    validate,
  }),
)(Profile);
